import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import { loadLanguageAsync } from "../plugins/i18n";
import localStorageService from "../store/services/local-storage-service";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbarFn(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbarFn(className);
    }, 100);
  }
}

export default {
  data() {
    return {};
  },
  async mounted() {
    // this.initScrollbar();
    this.loadCurrentUserLocale();
  },

  methods: {
    async loadCurrentUserLocale() {
      try {
        let me = await this.$store.getters["profile/me"];
        if (!me) {
          await this.$store.dispatch("profile/me");
          me = await this.$store.getters["profile/me"];
        }

        // let locale = localStorageService.get("GLOBAL_LOCALE");
        let locale = me?.locale;

        if (typeof localStorageService.get("GLOBAL_LOCALE") == "string") {
          locale = localStorageService.get("GLOBAL_LOCALE");
        }

        if (this.$i18n.locale !== locale) {
          loadLanguageAsync(locale);
        }
      } catch (e) {
        if (e.response) {
          if ([401, 403].includes(e.response.status)) {
            this.$store.dispatch("logout");
          }
        } else {
          throw e;
        }
      }
    },

    initScrollbar() {
      let isWindows = navigator.platform.startsWith("Win");
      if (isWindows) {
        initScrollbarFn("sidenav");
      }
    },
  },
};
